import { createReducer, on } from "@ngrx/store";
import * as fetchUserProfileAction from '../action/fetch-userProfile.action'
import { userProfileFetchState } from "../user-profile.state";
import * as functionalityAction from '../action/user-profile-funcionality.action'

const initialState: userProfileFetchState = {
    profileData: null,
    userDetails: null,
    updatedLegalEntity: null
}

export const fetchUserProfileReducer = createReducer(
    initialState,
    on(
        fetchUserProfileAction.fetchUserProfileActionSuccess,
        (state: userProfileFetchState, { profileData }) => ({
            ...state,
            profileData,
        })
    ), on(
        fetchUserProfileAction.storeUserDetailsAction,
        (state: userProfileFetchState, { userDetails }) => ({
            ...state,
            userDetails,
        })
    ),
    on(fetchUserProfileAction.updateShowButtonFlagAction, (state: userProfileFetchState) => ({
        ...state,
        profileData: {
            ...state.profileData,
            userData: {
                ...state.profileData.userData,
                showButtonFlag: !state.profileData.userData.showButtonFlag,
            },
        },
    })),
    on(fetchUserProfileAction.updatedLegalEntityAction, (state: userProfileFetchState, { updatedLegalEntity }) => ({
        ...state,
        updatedLegalEntity,
    })),
    on(functionalityAction.updateToggleAction, (state: userProfileFetchState) => ({
        ...state,
        profileData: {
            ...state.profileData,
            userData: {
                ...state.profileData.userData,
                adminToggleFlag: !state.profileData.userData.adminToggleFlag
            }
        },
    }))
    , on(functionalityAction.clearUserProfile,
        () => ({
            ...initialState
        }))
)